import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { ACCOUNT_NUMBER_DEFAULT_VALUE } from 'appConstants';
import { CustomersField } from 'fields';
import { useField } from 'formik';

import useFieldCustomers from 'hooks/useFieldCustomers';

export default function Customers({ name }) {
  const [{ value }, , { setValue }] = useField(name);
  const [{ value: multiAccount }, , { setValue: setMultiAccount }] = useField('multiAccount');
  const [, { value: isMultiAccountRequired }, { setValue: setIsMultiAccountRequired }] =
    useField('isMultiAccountRequired');
  const [{ value: addressNumber }, , { setValue: setAddressNumber }] = useField('addressNumber');

  const { t } = useTranslation('CreateCropOrder', { keyPrefix: 'CustomerDetails' });

  const { cmpNewValueToOld, loadAddressesFromOption } = useFieldCustomers('CreateCropOrder');

  const handleOnChange = useCallback(
    async (option) => {
      const newValueSameAsOld = cmpNewValueToOld(option, value);
      if (newValueSameAsOld) return;

      if (addressNumber) await setAddressNumber('');

      loadAddressesFromOption(option);

      await setValue(option || ACCOUNT_NUMBER_DEFAULT_VALUE, true);

      if (multiAccount) {
        await setMultiAccount('');
      }

      if (isMultiAccountRequired) {
        await setIsMultiAccountRequired(false);
      }
    },
    [
      value,
      setValue,
      cmpNewValueToOld,
      addressNumber,
      setAddressNumber,
      loadAddressesFromOption,
      multiAccount,
      isMultiAccountRequired,
      setMultiAccount,
      setIsMultiAccountRequired,
    ],
  );

  return (
    <CustomersField
      name={name}
      referenceKey="customerReference"
      textFieldProps={{
        label: t('labels.accountNumber'),
        placeholder: t('placeholders.accountNumber'),
        required: true,
      }}
      onChange={handleOnChange}
    />
  );
}
